"use client";

import { Box, Typography, Grid } from "@mui/material";
import SchoolIcon from "@mui/icons-material/School";
import { useMediaQuery, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import Counter from "./Counter";
import { siteStats } from "../../../data/siteStats";
import { CalendarMonth, LiveTv } from "@mui/icons-material";

// Icon + colour per stat; the numbers and labels are the homepage's (data/siteStats.js).
const statMeta = {
  programs: { icon: <SchoolIcon sx={{ fontSize: { xs: 28, md: 32 } }} />, color: "#27B94E" },
  weeksPerCohort: { icon: <CalendarMonth sx={{ fontSize: { xs: 28, md: 32 } }} />, color: "#F9960B" },
  liveClasses: { icon: <LiveTv sx={{ fontSize: { xs: 28, md: 32 } }} />, color: "#D15424" },
};

function StatsBar2() {
  const { t } = useTranslation();
  const stats = siteStats.map((s) => ({
    ...statMeta[s.key],
    count: String(s.value),
    suffix: s.suffix,
    label: t(`home.stats.${s.key}`),
  }));
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        padding: { xs: "32px 20px", md: "40px" },
        mt: "32px",
        backgroundColor: "#F7F8F7",
      }}
    >
      <Typography
        sx={{
          marginBottom: "2rem",
          fontSize: { xs: "24px", md: "32px" },
          fontWeight: "bold",
        }}
      >
        {t("about.stats.title")}
      </Typography>

      <Box
        sx={{
          width: "90%",
          maxWidth: "1128px",
          height: "auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          margin: "0 auto",
        }}
      >
        <Grid
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {stats.map((stat, index) => (
            <Grid item xs={12} sm={4} key={index} sx={{ textAlign: "center" }}>
              {isMobile ? (
                // Mobile layout - Icon on top, text below
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: "#f5f5f7",
                      borderRadius: "50%",
                      width: "64px",
                      height: "64px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mb: 1.5,
                      color: "#333",
                    }}
                  >
                    {stat.icon}
                  </Box>
                  <Counter
                    end={stat?.count}
                    suffix={`${stat.suffix} `}
                    component="span"
                    color={stat?.color}
                    sx={{
                      fontWeight: 700,
                      mr: 0.5,
                      fontSize: "20px",
                    }}
                  />

                  <Typography
                    variant="body1"
                    sx={{
                      color: "#333",
                      fontWeight: 500,
                      fontSize: "12px",
                    }}
                  >
                    {stat.label}
                  </Typography>
                </Box>
              ) : (
                // Desktop layout - Icon and text side by side
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: "#f5f5f7",
                      borderRadius: "50%",
                      width: "56px",
                      height: "56px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mr: 2,
                      color: "#666",
                    }}
                  >
                    {stat.icon}
                  </Box>
                  <Box sx={{ textAlign: "left" }}>
                    <Counter
                      end={stat?.count}
                      suffix={`${stat.suffix} `}
                      component="span"
                      color={stat?.color}
                      sx={{
                        fontWeight: 700,
                        mr: 0.5,
                        fontSize: "32px",
                      }}
                    />
                    <Typography
                      variant="body2"
                      sx={{
                        color: "#666",
                        fontWeight: 500,
                        fontSize: "16px",
                      }}
                    >
                      {stat.label}
                    </Typography>
                  </Box>
                </Box>
              )}
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}

export default StatsBar2;
